<div class="header-ny">
  <div class="header-ny__content">
    <div class="header-ny__policy-info">
      <div class="header-ny__policy-item header-ny__policy-item--primary">
        Individual Life Insurance Application for {{ insuredName }}
      </div>
      <div class="header-ny__policy-layout-container">
        <div class="header-ny__policy-items-container header-ny__policy-items-container--filing-no">
          <div class="header-ny__policy-item header-ny__policy-item--secondary">
            {{ filingNumber }}
          </div>
          <div class="hidden-tablet-up">&nbsp;</div>
          <div class="header-ny__policy-item header-ny__policy-item--secondary">Form No.</div>
        </div>
        <div class="header-ny__policy-item-divider hidden-mobile"></div>
        <div class="header-ny__policy-layout-container-break hidden-tablet-up"></div>
        <div class="header-ny__policy-items-container">
          <div class="header-ny__policy-item header-ny__policy-item--secondary">
            {{ formattedCoverageAmount }}
          </div>
          <div class="header-ny__policy-item header-ny__policy-item--secondary">Coverage</div>
        </div>
        <div class="header-ny__policy-item-divider header-ny__hidden-tablet"></div>
        <div class="header-ny__policy-layout-container-break header-ny__show-for-desktop"></div>
        <div class="header-ny__policy-items-container header-ny__policy-items-container--product">
          <div class="header-ny__policy-item header-ny__policy-item--secondary">
            {{ getPolicyText() }}
          </div>
        </div>
      </div>
    </div>
    <div class="header-ny__mm-info">
      <div class="header-ny__mm-item header-ny__mm-item--primary">Massachusetts Mutual Life Insurance Company</div>
      <div class="header-ny__mm-item header-ny__mm-item--secondary">
        <span class="header-ny__home-office">Home Office:</span>
        {{ homeOfficeAddress }}
      </div>
      <div class="header-ny__mm-item header-ny__mm-item--secondary">
        <span class="header-ny__admin-office">Administrative Office:</span>
        {{ adminOfficeAddress }}
      </div>
    </div>
  </div>
</div>
